import React from 'react';
import { Image } from 'react-bootstrap';
import classes from './BitstrayInfoRowButton.module.css';

interface BitstrayInfoRowButtonProps {
  iconImgSource: string;
  btnText: string;
  onClickHandler: () => void;
}

const BitstrayInfoRowButton: React.FC<BitstrayInfoRowButtonProps> = props => {
  const { iconImgSource, btnText, onClickHandler } = props;
  return (
    <div className={classes.bitstrayButton} onClick={onClickHandler}>
      <div className={classes.bitstrayButtonContents}>
        <Image src={iconImgSource} className={classes.buttonIcon} />
        {btnText}
      </div>
    </div>
  );
};

export default BitstrayInfoRowButton;
